import { render } from "./PostContainer.vue?vue&type=template&id=28463d71&scoped=true"
import script from "./PostContainer.vue?vue&type=script&lang=js"
export * from "./PostContainer.vue?vue&type=script&lang=js"

import "./post-container.scss?vue&type=style&index=0&id=28463d71&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28463d71"]])

export default __exports__